import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { UserContext } from '../../../api/userContext';


const AdminRoute = ({ component: Component, ...rest }) => {
    const { user, isAdmin } = useContext(UserContext);

    console.log('user', user);

    return (
        <Route
            {...rest}
            render={props => {
                if (user && isAdmin) {
                    return <Component {...props} />;
                } else {
                    return <Redirect to={user ? "/" : "/login"} />;
                }
            }}
        />
    );
}

export default AdminRoute;